import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Stack, TablePagination } from '@mui/material';
import type { GridRowSelectionModel } from '@mui/x-data-grid';
import {
  gridPageSelector,
  gridRowSelectionStateSelector,
  GridSelectedRowCount,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';

import { styles } from './index.styles';

interface ShareUserListFooterProps {
  isFullSelection: boolean;
  onSelectAll: () => void;
  rowCount: number; // Pass rowCount manually as the `useGridSelector`-hook does not provide a reliable value.
  rowsPerPage: number;
}

export const ShareUserListFooter: FC<ShareUserListFooterProps> = ({
  isFullSelection,
  onSelectAll,
  rowCount,
  rowsPerPage,
}) => {
  const { t } = useTranslation('report');
  const apiRef = useGridApiContext();
  const selectionModel = useGridSelector(
    apiRef,
    gridRowSelectionStateSelector,
  ) as GridRowSelectionModel;
  const page = useGridSelector(apiRef, gridPageSelector);

  return (
    <Stack className="ShareUserList-root" sx={styles.shareUserListFooter}>
      <Stack direction="row">
        <GridSelectedRowCount
          selectedRowCount={
            isFullSelection ? rowCount : selectionModel?.ids?.size ?? 0
          }
        />

        <Button
          data-test-id="share-user-admin-select-all-button"
          onClick={() => onSelectAll()}
          variant="text"
        >
          {t('reportInfo.selectAll')}
        </Button>
      </Stack>

      <TablePagination
        count={rowCount}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[]}
        onPageChange={(event, value) => apiRef.current.setPage(value)}
        component="div"
      />
    </Stack>
  );
};

export default ShareUserListFooter;
